import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Typography, Link,
} from '@material-ui/core';
import useStyles from './useStyles';
import { Button } from '../../../../../components';

const ModalWelcomeMessage = ({
  onAccept,
  title,
  bodyContent,
  privacyContent,
  footerContent,
  extraContent,
  continueButtonText,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.welcomeMessageContainer}>
      <Typography className={classes.welcomeMessageTitle}>
        {title}
      </Typography>
      <Box className={classes.contentContainer}>

        <Typography className={classes.welcomeMessageSubtitle}>
          {bodyContent}
        </Typography>

        {privacyContent && (
          <Typography className={classes.welcomeMessageSubtitle}>
            {privacyContent}
            <Link
              href="/aviso-privacidad"
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
              underline="always"
            >
              {' Aviso de Privacidad.'}
            </Link>
          </Typography>
        )}
        {
          footerContent && (
            <Typography className={classes.welcomeMessageSubtitle}>
              {footerContent}
            </Typography>
          )
        }

        {
          extraContent && (
            <Typography
              className={classes.welcomeMessageSubtitle}
            >
              <b>Importante:</b>
              {` ${extraContent}`}
            </Typography>
          )
        }
      </Box>

      <Button
        color="primary"
        onClick={onAccept}
        className={classes.continueButton}
      >
        {continueButtonText}
      </Button>
    </Box>
  );
};

ModalWelcomeMessage.propTypes = {
  onAccept: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  bodyContent: PropTypes.string.isRequired,
  footerContent: PropTypes.string,
  privacyContent: PropTypes.string,
  extraContent: PropTypes.string,
  continueButtonText: PropTypes.string.isRequired,
};

ModalWelcomeMessage.defaultProps = {
  footerContent: '',
  extraContent: '',
  privacyContent: '',
};

export default ModalWelcomeMessage;
